import React from 'react'
import ContactSection from './TeamMember'

const Contact = () => {
  return (
    <div className='navFixMargin'>
      <ContactSection />
    </div>
  )
}

export default Contact